<template>
  <div class="tab-pane-content">
    <div class="section-header">
      <div class="section-header__icon section-header__icon--info">
        <feather-icon
          icon="GlobeIcon"
          size="20"
        />
      </div>
      <div>
        <h4 class="mb-0">
          Saber Accounts
        </h4>
        <small class="text-muted">Manage your Saber platform credentials by region</small>
      </div>
    </div>

    <!-- Dubai -->
    <div class="saber-region mt-2 saber-region--dubai">
      <div class="saber-region__header">
        <feather-icon
          icon="MapPinIcon"
          size="16"
          class="mr-50"
        />
        <h5 class="mb-0">
          Dubai
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="MailIcon"
              size="14"
              class="mr-50 text-primary"
            />
            Email
          </label>
          <b-form-input
            v-model="form.saber_email_dubai"
            type="email"
            placeholder="Dubai Saber email"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="LockIcon"
              size="14"
              class="mr-50 text-primary"
            />
            Password
          </label>
          <b-input-group>
            <b-form-input
              v-model="form.saber_password_dubai"
              :type="showSaberPass.dubai ? 'text' : 'password'"
              placeholder="Dubai Saber password"
            />
            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showSaberPass.dubai = !showSaberPass.dubai"
              >
                <feather-icon
                  :icon="showSaberPass.dubai ? 'EyeOffIcon' : 'EyeIcon'"
                  size="14"
                />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <!-- Manila -->
    <div class="saber-region mt-2 saber-region--manila">
      <div class="saber-region__header">
        <feather-icon
          icon="MapPinIcon"
          size="16"
          class="mr-50"
        />
        <h5 class="mb-0">
          Manila
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="MailIcon"
              size="14"
              class="mr-50 text-success"
            />
            Email
          </label>
          <b-form-input
            v-model="form.saber_email_manila"
            type="email"
            placeholder="Manila Saber email"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="LockIcon"
              size="14"
              class="mr-50 text-success"
            />
            Password
          </label>
          <b-input-group>
            <b-form-input
              v-model="form.saber_password_manila"
              :type="showSaberPass.manila ? 'text' : 'password'"
              placeholder="Manila Saber password"
            />
            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showSaberPass.manila = !showSaberPass.manila"
              >
                <feather-icon
                  :icon="showSaberPass.manila ? 'EyeOffIcon' : 'EyeIcon'"
                  size="14"
                />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <!-- Hungary -->
    <div class="saber-region mt-2 saber-region--hungary">
      <div class="saber-region__header">
        <feather-icon
          icon="MapPinIcon"
          size="16"
          class="mr-50"
        />
        <h5 class="mb-0">
          Hungary
        </h5>
      </div>
      <b-row class="mt-1">
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="MailIcon"
              size="14"
              class="mr-50 text-warning"
            />
            Email
          </label>
          <b-form-input
            v-model="form.saber_email_hungary"
            type="email"
            placeholder="Hungary Saber email"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-1"
        >
          <label class="form-label-icon">
            <feather-icon
              icon="LockIcon"
              size="14"
              class="mr-50 text-warning"
            />
            Password
          </label>
          <b-input-group>
            <b-form-input
              v-model="form.saber_password_hungary"
              :type="showSaberPass.hungary ? 'text' : 'password'"
              placeholder="Hungary Saber password"
            />
            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="showSaberPass.hungary = !showSaberPass.hungary"
              >
                <feather-icon
                  :icon="showSaberPass.hungary ? 'EyeOffIcon' : 'EyeIcon'"
                  size="14"
                />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <div class="d-flex justify-content-end mt-2 pt-1 border-top">
      <b-button
        variant="primary"
        class="profile-primary-btn"
        :disabled="isSaving"
        @click="updateProfile"
      >
        <b-spinner
          v-if="isSaving"
          small
          class="mr-50"
        />
        <feather-icon
          v-else
          icon="SaveIcon"
          size="14"
          class="mr-50"
        />
        Save Changes
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaberAccountsTab',
  props: {
    form: {
      type: Object,
      required: true,
    },
    isSaving: {
      type: Boolean,
      default: () => false,
    },
    updateProfile: {
      type: Function,
      required: true,
    },
    showSaberPass: {
      type: Object,
      required: true,
    },
  },
}
</script>
<!-- eof -->
<!-- eof2 -->
